import { useState } from 'react';
import {
  INLINE_COOKIE_CUSTOM_EVENT_NAMES,
  PRIVACY_CORE_CUSTOM_EVENT_NAMES,
  getPrivacyCoreEventName,
  getInlineEventName,
} from '@nike/privacy-shared-logic';
import { useEventListener } from '@nike/privacy-shared-react';

/**
 * @name useLoader
 * @param {string} uniqueEventsPrefix - A unique extra prefix for custom events
 * @description Hook which uses to get a loading state
 * @returns {boolean}
 */
export const useLoader = (uniqueEventsPrefix: string): boolean => {
  const [isLoading, setIsLoading] = useState(false);

  useEventListener(
    getPrivacyCoreEventName(
      PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATING,
      uniqueEventsPrefix,
    ),
    () => {
      setIsLoading(true);
    },
  );

  useEventListener(
    getPrivacyCoreEventName(
      PRIVACY_CORE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATE_ERROR,
      uniqueEventsPrefix,
    ),
    () => {
      setIsLoading(false);
    },
  );

  useEventListener(
    getInlineEventName(
      INLINE_COOKIE_CUSTOM_EVENT_NAMES.PERMISSIONS_UPDATE_ERROR,
      uniqueEventsPrefix,
    ),
    () => {
      setIsLoading(false);
    },
  );

  return isLoading;
};
